(() => {
  if (customElements.get('component-tabs')) {
    return;
  }

  class ComponentTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.attachHandlers();
      this.setBubblePosition();
    }

    initElements() {
      this.tabsNavButtons = this.querySelectorAll('[data-tab-button]');
      this.bubble = this.querySelector('[data-nav-bubble]');
      this.tabs = this.querySelectorAll('[data-tab]');
    }

    attachHandlers() {
      this.tabsNavButtons.forEach((button) => {
        button.addEventListener('click', this.handleTabButtonClick.bind(this));
      });
      window.addEventListener('resize', () => this.setBubblePosition());
    }

    toggleTabButtonActive(button) {
      this.tabsNavButtons.forEach((tabsNavButton) => {
        tabsNavButton.classList.toggle('is-active', button === tabsNavButton);
      });
    }

    handleTabButtonClick(event) {
      event.preventDefault();

      this.toggleTabButtonActive(event.target);
      this.setBubblePosition();
      this.toggleTabs(event.target);
    }

    setBubblePosition() {
      const activeButton = Array.from(this.tabsNavButtons).find((button) =>
        button.classList.contains('is-active'),
      );

      if (!this.bubble) {
        return;
      }

      this.bubble.style.right = 'auto';
      this.bubble.style.left = `${activeButton.offsetLeft}px`;
      this.bubble.style.top = `${activeButton.offsetTop}px`;
      this.bubble.style.width = `${activeButton.clientWidth}px`;
      this.bubble.style.height = `${activeButton.clientHeight}px`;
    }

    toggleTabs(button) {
      const targetTab = this.querySelector(`#${button.dataset.tabId}`);

      if (!targetTab) {
        return;
      }

      this.tabs.forEach((tab) =>
        tab.classList.toggle('is-active', tab === targetTab),
      );
    }
  }

  customElements.define('component-tabs', ComponentTabs);
})();
